import type { SubscriptionState } from '@features/customers/constants';
import { SUBSCRIPTION_STATE_LABELS, SubscriptionStates } from '@features/customers/constants';

import s from './SubscriptionBadge.module.css';

const STATE_CLASSES: Record<SubscriptionState, string> = {
  [SubscriptionStates.ACTIVE]: s.active,
  [SubscriptionStates.CANCELED]: s.canceled,
  [SubscriptionStates.NONE]: s.none,
};

type SubscriptionBadgeProps = {
  state: SubscriptionState;
};

function SubscriptionBadge({ state }: SubscriptionBadgeProps) {
  return (
    <span className={`${s.badge} ${STATE_CLASSES[state]}`}>
      <span className={s.badgeDot} />
      <span className={s.badgeLabel}>{SUBSCRIPTION_STATE_LABELS[state]}</span>
    </span>
  );
}

export default SubscriptionBadge;
